import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["layer", "topLayer"]

    connect() {
        this.currentIndex = 0
        this.interval = null
        this.isTransitioning = false

        // Initialize all layers
        this.layerTargets.forEach((layer, index) => {
            layer.classList.remove("hidden")
            layer.style.opacity = index === 0 ? "1" : "0"
            layer.style.transition = "opacity 3s ease-in-out"
            layer.style.pointerEvents = index === 0 ? "auto" : "none"

            // Set initial scale to 1 for all zoom images
            const zoomImages = layer.querySelectorAll('.zoom-image')
            zoomImages.forEach(img => img.style.scale = '1')
        })

        // Initialize all top layers
        this.topLayerTargets.forEach((topLayer, index) => {
            topLayer.classList.remove("hidden")
            topLayer.style.opacity = index === 0 ? "1" : "0"
            topLayer.style.transition = "opacity 3s ease-in-out"
            topLayer.style.pointerEvents = index === 0 ? "auto" : "none"

            // Set initial scale to 1 for all zoom images in top layers
            const zoomImages = topLayer.querySelectorAll('.zoom-image')
            zoomImages.forEach(img => img.style.scale = '1')
        })

        // Trigger zoom for first layer and top layer after a short delay
        setTimeout(() => {
            this.applyZoomEffect(this.layerTargets[0], true)
            if (this.topLayerTargets[0]) {
                this.applyZoomEffect(this.topLayerTargets[0], true)
            }
        }, 50)

        // Position logos korrekt
        this.updateLogoPositions()

        // Rotation starten
        this.startRotation()

        // Reposition logos on resize
        window.addEventListener('resize', () => this.updateLogoPositions())
    }

    disconnect() {
        this.stopRotation()
        window.removeEventListener('resize', this.updateLogoPositions)
    }

    startRotation() {
        this.interval = setInterval(() => this.showNextLayer(), 10000)
    }

    stopRotation() {
        if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
        }
    }

    applyZoomEffect(layer, apply) {
        const zoomImages = layer.querySelectorAll('.zoom-image')
        this.zoomEffect(zoomImages, '1.2', apply)
    }

    zoomEffect(images, scale, apply) {
        images.forEach(img => img.style.scale = apply ? scale : '1')
    }

    showNextLayer() {
        if (this.isTransitioning) return
        this.isTransitioning = true

        const currentLayer = this.layerTargets[this.currentIndex]
        const currentTopLayer = this.topLayerTargets[this.currentIndex]
        const nextIndex = (this.currentIndex + 1) % this.layerTargets.length
        const nextLayer = this.layerTargets[nextIndex]
        const nextTopLayer = this.topLayerTargets[nextIndex]

        // Fade out current layers
        this.applyZoomEffect(currentLayer, false)
        currentLayer.style.opacity = "0"
        currentLayer.style.pointerEvents = "none"

        if (currentTopLayer) {
            this.applyZoomEffect(currentTopLayer, false)
            currentTopLayer.style.opacity = "0"
            currentTopLayer.style.pointerEvents = "none"
        }

        // Fade in next layers
        nextLayer.style.opacity = "1"
        nextLayer.style.pointerEvents = "auto"
        this.applyZoomEffect(nextLayer, true)

        if (nextTopLayer) {
            nextTopLayer.style.opacity = "1"
            nextTopLayer.style.pointerEvents = "auto"
            this.applyZoomEffect(nextTopLayer, true)
        }

        this.currentIndex = nextIndex

        setTimeout(() => this.isTransitioning = false, 3000)
    }

    updateLogoPositions() {
        const logoContainer = document.querySelector('.logo-wrapper')
        const sidebarContainer = document.querySelector('.sidebar')
        if (!logoContainer || !sidebarContainer) return

        const logoRect = logoContainer.getBoundingClientRect()
        const sidebarRect = sidebarContainer.getBoundingClientRect()

        const offset = sidebarRect.height - logoRect.height

        this.layerTargets.forEach(layer => {
            const logoImages = layer.querySelectorAll('.logo')
            logoImages.forEach(img => {
                img.style.transition = 'none'
                img.style.position = 'relative'
                img.style.top = `-${offset - 25}px`
            })
        })

        // Update logo positions in top layers as well
        this.topLayerTargets.forEach(topLayer => {
            const logoImages = topLayer.querySelectorAll('.logo')
            logoImages.forEach(img => {
                img.style.transition = 'none'
                img.style.position = 'relative'
                img.style.top = `-${offset - 25}px`
            })
        })
    }
}
